// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__sqRA5","info":"UpdateTermsInfo_info__1u4iw"};